module.exports = __webpack_public_path__ + "static/media/qrcode.946abc80.jpeg";